<template>
	<v-container v-if="$vuetify.breakpoint.mdAndUp" fluid>
		<v-row class="d-flex justify-center align-center custom-v-card">
			<v-container class="container-mysales">
				<template>
					<h2 class="duo" style="font-size: 28px">my<b style="font-family: 'AirNZ Sans Semibold' !important">sales</b></h2>
				</template>

				<v-row no-gutters class="my-0" style="border-bottom: 2px solid black"> </v-row>

				<template>
					<!-- hide-default-header hide-default-footer disable-pagination -->
					<v-data-table 
						:headers="headers" 
						:items="stampList" 
						:search="keyword" 
						:items-per-page="12">
						<template v-slot:top>
							<v-row no-gutters style="padding: 20px 10px 15px" justify="end">
								<v-col cols="12" sm="4">
									<div class="d-flex px-2">
										<v-text-field v-model="keyword" append-icon="mdi-magnify" label="Search" hide-details style="margin-right: 10px"></v-text-field>
									</div>
								</v-col>
							</v-row>
						</template>

						<template v-slot:item.bookingCode="{ item }">
							<span>{{ item.bookingCode == null ? " - " : item.bookingCode }}</span>
						</template>

						<template v-slot:item.ticketNumber="{ item }">
							<span>{{ item.ticketNumber == null ? " - " : item.ticketNumber }}</span>
						</template>

						<template v-slot:item.creationDate="{ item }">
							<span>{{ new Date(item.creationDate).getDate() + "-" + new Date(item.creationDate).toLocaleString('en-US', { month: 'short' }) + "-" + String(new Date(item.creationDate).getFullYear()).slice(-2) }}</span>
						</template>

						<template v-slot:item.btn2="{ item }">
							<div style="margin-right: 5.8px">
								<v-btn :id="'btn-delete-' + item.stamp == 'NZ' ? item.bookingCode : item.ticketNumber" tile small icon @click="deleteitem(item)" class="no-background-hover mr-0">
									<svg xmlns="http://www.w3.org/2000/svg" width="15" height="17.02" viewBox="0 0 15.084 17.112">
										<path
											class="a"
											d="M5.3,18.143h7.314a1.659,1.659,0,0,0,1.185-.4,1.62,1.62,0,0,0,.46-1.161l.489-11.191h1.108a.628.628,0,0,0,.456-.183.617.617,0,0,0,.187-.46.6.6,0,0,0-.187-.444.628.628,0,0,0-.456-.183H2.051A.618.618,0,0,0,1.6,4.3a.6.6,0,0,0-.187.444.633.633,0,0,0,.635.643H3.167l.489,11.191A1.611,1.611,0,0,0,4.12,17.74,1.662,1.662,0,0,0,5.3,18.143Zm1.2-2.3a.516.516,0,0,1-.362-.13.486.486,0,0,1-.151-.358l-.22-8.275a.447.447,0,0,1,.13-.354.515.515,0,0,1,.375-.134.505.505,0,0,1,.354.13.486.486,0,0,1,.151.358L7,15.358a.447.447,0,0,1-.13.354A.515.515,0,0,1,6.5,15.846Zm2.46,0a.53.53,0,0,1-.379-.134.454.454,0,0,1-.143-.346V7.083a.464.464,0,0,1,.143-.354.6.6,0,0,1,.753,0,.458.458,0,0,1,.147.354v8.283a.448.448,0,0,1-.147.346A.533.533,0,0,1,8.958,15.846Zm2.452,0a.515.515,0,0,1-.375-.134.471.471,0,0,1-.138-.354l.236-8.275a.486.486,0,0,1,.151-.358.579.579,0,0,1,.737,0,.447.447,0,0,1,.13.354l-.236,8.283a.451.451,0,0,1-.143.35A.516.516,0,0,1,11.41,15.846ZM5.423,4.379H6.93V3.027a.572.572,0,0,1,.175-.44.672.672,0,0,1,.476-.163h2.737a.687.687,0,0,1,.481.163.565.565,0,0,1,.179.44V4.379h1.5V2.953a1.833,1.833,0,0,0-.55-1.409,2.139,2.139,0,0,0-1.519-.513H7.484a2.127,2.127,0,0,0-1.511.513,1.833,1.833,0,0,0-.55,1.409Z"
											transform="translate(-1.416 -1.031)"
										/>
									</svg>
								</v-btn>
							</div>
						</template>
					</v-data-table>
				</template>
				
			</v-container>
		</v-row>

		<!---Delete Ticket--->
		<v-dialog v-model="dialogDelete" width="505px">
			<v-card class="white" height="100%" :style="{ borderRadius: '8px'}">
				<v-card-title class="pa-0" height="66px" :style="{ backgroundColor: '#440099' }">
					<div :style="{ margin: '18px 17px 18px 24.5px' }">
						<v-img width="30px" height="30px" :src="$bucket + '/image/warning.svg'" contain style="color: white;"></v-img>
					</div>
					<div>
						<span class="notification-title-text-style" style="color: white;">Warning</span>
					</div>
				</v-card-title>
				<v-card-text class="pa-0 px-3 py-3" height="190.71px">
					<div class="notification-content-warning-style">
						<div>
							<div class="notification-content-text-style">Are you sure you want to delete this booking?</div>
						</div>
					</div>
				</v-card-text>
				<v-card-actions class="px-0 pt-0 justify-center">
					<v-col cols="6">
						<v-btn @click="submitDelete(selectedRow)" class="pa-0 mr-0" color="#2d2926" :elevation="0" height="50px" block bottom dark>
							<span class="regular-text-style">Delete</span>
						</v-btn>
					</v-col>
					<v-col cols="6">
						<v-btn @click="dialogDelete = false" class="pa-0 mr-0" color="#2d2926" :elevation="0" height="50px" block bottom outlined>
							<span class="regular-text-style" style="color: black !important;">Cancel</span>
						</v-btn>
					</v-col>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-container>
</template>

<style scoped>
.custom-v-card {
	border-radius: 8px;
	background-color: rgba(255, 255, 255, 0.9);
	color: rgba(0, 0, 0, 0.87);
	border-width: thin;
	max-width: 100%;
	outline: none;
	text-decoration: none;
	transition-property: box-shadow, opacity;
	overflow-wrap: break-word;
	position: relative;
	white-space: normal;
	min-height: 166px;
	opacity: 0.9;
	margin-left: 0.01vw;
}
.mysales.v-data-table > .v-data-table__wrapper > table > tbody > tr > td.text-end {
	/* border-bottom: thin solid rgba(0, 0, 0, 0.12); */
	padding-right: 0;
	font-size: 0.875rem;
	height: 48px;
}
.v-application--is-ltr .v-text-field .v-label {
	color: black !important;
	font-size: 14px !important;
	font-family: "AirNZ Sans Regular" !important;
}
.theme--light.v-data-table {
	background-color: transparent !important;
	color: rgba(0, 0, 0, 0.87);
}
.cleariconsize.v-select__selections {
	font-size: 14px;
}
.cleariconsize .v-input__append-inner .icon-duo-close {
	font-size: 14px;
}
.cleariconsize.v-input input {
	font-size: 14px !important;
}
.cleariconsize .v-select__selection--comma {
	margin: 7px 4px 7px 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 14px;
}
.cleariconsize .mdi-menu-down::before {
	content: "\F0140";
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
	font-size: 14px !important;
	font-family: "AirNZ Sans Regular" !important;
	color: black !important;
	text-align: center;
	font-weight: 400;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th {
	font-size: 13px !important;
	text-align: center !important;
	font-family: "AirNZ Sans Regular" !important;
}
.theme--light.v-expansion-panels .custom-color.v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
	color: black !important;
}
.v-expansion-panel--active > .v-expansion-panel-header {
	min-height: 54px;
}
.v-expansion-panels > .v-expansion-panel {
	background: rgba(255, 255, 255, 0.9) !important;
	border-radius: 6px !important;
}
.no-background-hover::before {
	background-color: transparent !important;
}
.title-line {
	border: 1px solid black;
	background-color: black;
	margin-top: -3px;
	width: 50%;
}
.active-line {
	border: 3.5px solid black;
	background-color: black;
	margin-top: 10px;
}
.non-active-line {
	border: 1px solid transparent;
	background-color: transparent;
}
.v-input__icon--append-outer .v-icon {
	background-color: #221551 !important;
	color: white !important;
	padding: 5px;
}
.btn-search {
	width: 40px;
	height: 40px;
	background-color: #440099;
	border-radius: 4px;
	margin-left: 10px;
}
.container-mysales {
	width: 100%;
}
.v-data-table-header th {
  white-space: nowrap;
}
@media (max-width: 1200px) {
	.container-mysales {
		width: 95%;
	}
}
@media (max-width: 600px) {
	.theme--light.v-label {
		color: black !important;
		font-size: 14px !important;
	}
	.row-pnr-input {
		padding: 0 10px 10px 10px;
	}
	.container-mysales {
		padding: 0px 5px;
		margin-top: 40px;
	}
}
.v-expansion-panel::before {
	box-shadow: none;
}
</style>

<script>
/* eslint-disable no-console */
/* eslint-disable no-empty */
/* eslint-disable no-extra-boolean-cast */
import axios from "axios";

export default {
	components: {
	},
	data() {
		return {
			panel: [0],
			month_names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
			month_names_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			dialogDelete: false,
			totalValidated: 0,
			totalPending: 0,
			totalMatched: 0,
			totalError: 0,
			selectedMonthYearindex: 0,
			selectedRow: [],
			selectedindex: 0,
			pnr: "",
			statusItems: ["Validated", "Pending", "Matched_PNR", "Error"],
			status: [],
			departure: [],
			departureItems: ["SYD", "BNE", "OOL", "MCY", "CNS", "PER", "ADL", "MEL", "HBA"],
			arrival: [],
			arrivalItems: ["AKL", "WLG", "CHC", "ZQN", "RAR", "NOR", "HBA"],
			final: [],
			finalItems: ["LAX", "HNL", "SFO", "IAH", "ORD"],
			campaign: [],
			bookingCodes: [],
			groupBooking: [],
			bookingList: [],
			search: [],
			headers: [
				{ text: "PNR Type", value: "stamp", sortable: false, align: "start" },
				{ text: "PNR Code", value: "bookingCode", align: "center" },
				{ text: "UA Code", value: "ticketNumber", align: "center" },
				{ text: "Date Created", value: "creationDate", align: "center" },
				{ text: "", value: "btn2", sortable: false, align: "end", class: "delete" }
			],
			dataTable: [],
			datacache: [],
			allowedDates: (val) => val <= new Date().toJSON().slice(0, 10).replace(/-/g, "-") && val >= new Date(new Date().getTime() + -90 * 24 * 60 * 60 * 1000).toJSON().slice(0, 10).replace(/-/g, "-"),

			stampList: [],
			keyword: "",
		};
	},

	mounted: function () {
		this.initialize();
	},

	methods: {

		initialize() {
			this.loadgrid();
			this.$root.$on("update", this.loadgrid);
		},

		loadgrid() {
			axios
				.get("/system/passport/list/me")
				.then((response) => {
					this.stampList = response.data;
					this.$emit("on-load-grid", this.stampList.length);
				})
				.catch(() => {});
		},

		deleteitem(row) {
			this.selectedRow = row;
			this.dialogDelete = true;
		},

		submitDelete(rowSelected) {
			axios
				.get("/system/passport/delete", { params: { id: rowSelected.id } })
				.then(() => {
					this.closeDelete();
					this.$emit("on-change");
				})
				.catch(() => {});
		},

		closeDelete() {
			this.initialize();
			this.dialogDelete = false;
		},

	}
};
</script>
